import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';
import useAddSensorComment from '../hooks/useAddSensorComment';
import useSensorStore from '../store/sensorStore';
import Textarea from './Textarea';

const InputWrap = styled('div')({
  margin: '5px 3px 0px',
  width: 400,
});

interface CommentsFormProps {
  open: boolean;
  handleClose: () => void;
  installationId?: number;
  title?: string;
}

const CommentsForm = ({ open, handleClose, installationId, title = "Add New Comment" }: CommentsFormProps) => {
  const [value, setValue] = useState<string>('');

  const { addSensorComment } = useAddSensorComment();

  const onCommentTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setValue(value);
  };

  const handleSave = () => {
    // @ts-ignore
    addSensorComment(value, installationId);
    setValue('');
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <InputWrap>
          <Textarea
            aria-label="minimum height"
            placeholder="Add comment"
            value={value}
            onChange={onCommentTextChange}
          />
        </InputWrap>
      </Box>
      <div style={{ display: 'flex', padding: '8px' }}>
        <Button disabled={value.length < 3} sx={{ flex: 1 }} color="primary" startIcon={<CheckIcon />} onClick={handleSave}>
          Add
        </Button>
        <Button sx={{ flex: 1 }} color="error" startIcon={<CloseIcon />} onClick={handleClose}>
          close
        </Button>
      </div>
    </Dialog>
  );
};

export default CommentsForm;
